import React, { Component } from 'react';

import { MyContext } from '../../../context';
import { queryGetConfigData, getProcessingRegions, getAllCustomFieldDefinitions, queryGetAWSRegions } from "../../../queries/querySettings";
import { toast } from 'react-toastify';
import Utils from '../../common/Utils';
import UserPicker from '../../ReportView/ReportConfiguration/UserPicker';
import DateTimePicker from 'react-datetime-picker';

import gql from 'graphql-tag';
import { Query } from "@apollo/react-components";

import {
    DefaultButton,
    PrimaryButton,
    Stack,
    TextField,
    ComboBox, Checkbox, Spinner, Text, Label, SpinButton, ChoiceGroup
    , Toggle, SelectableOptionMenuItemType,
    TooltipHost, Icon
} from "office-ui-fabric-react";

// Helper
function isDigits(val, maxLength = 2) {
    const pattern = new RegExp(`^\\d{0,${maxLength}}$`);
    return pattern.test(val);
}
// Mode detection: distinguishes legacy, flexible, and daily modes based on DB fields
function detectMode(day, hour, minute, startDateTime) {
    if (Number(day) === 0 && !startDateTime && Number(hour) === 0 && Number(minute) === 0) return "legacy";
    if (Number(day) === 0 && !startDateTime && (Number(hour) > 0 || Number(minute) > 0)) return "flexible";
    if (Number(day) > 0) return "daily";
    return "unknown";
}

function isValidS3BucketName(value) {
    const bucket = String(value || "").trim();

    if (bucket.length < 3 || bucket.length > 63) return false;
    if (!/^[a-z0-9][a-z0-9.-]*[a-z0-9]$/.test(bucket)) return false;
    if (bucket.includes("..")) return false;
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(bucket)) return false;

    return true;
}

// Genesys call deletion is scheduled daysUntilDeletion days after archiving. 0 is a valid,
// legitimate value (e.g. delete right away / not configured); only negative values are invalid.
function isValidDaysUntilDeletion(value) {
    return Number(value) >= 0;
}
// Initial state setup 
function getInitialState(props) {
    const ttlCustomFieldMapping = props.data?.ttlCustomFieldMapping
        ? props.data.ttlCustomFieldMapping
        : { sourcekey: "", sourcevalue: "", customfieldId: "" };

    const filterAttribute = props.data?.filterAttribute
        ? props.data.filterAttribute
        : { key: "", value: "" };

    // Initialize custom field mapping
    let customFieldMappings = [{ input: "", combo: "" }];
    let initialFetchCycleDay, initialFetchCycleHour, initialFetchCycleMinute, fetchStartDateTime;

    if (props.data && props.data.customFieldMappings) {
        let dict = {};
        try {
            dict = JSON.parse(props.data.customFieldMappings);
        } catch (e) {
            dict = {};
        }
        if (Array.isArray(dict)) {
            customFieldMappings = dict;
        } else if (typeof dict === "object" && dict !== null) {
            customFieldMappings = Object.entries(dict).map(([key, value]) => ({
                input: key,
                combo: value
            }));
        }
    }

    if (props.isNew) {
        // New integration: Flexible mode, 30 min interval
        initialFetchCycleDay = 0;
        initialFetchCycleHour = 0;
        initialFetchCycleMinute = 30;
        fetchStartDateTime = null; // Not used in flexible mode
    } else {
        console.log("existing integration day", props.data.fetchCycleDay);
        console.log("existing integration hour", props.data.fetchCycleHour);
        console.log("existing integration minute", props.data.fetchCycleMinute);
        console.log("existing integration fetchStartDateTime", props.data.fetchStartDateTime);
        // Existing/legacy integration
        const hour = props.data.fetchCycleHour;
        const minute = props.data.fetchCycleMinute;
        const startDateTime = props.data?.fetchStartDateTime;
        const day = props.data.fetchCycleDay;

        // Legacy detection: day=0 AND no startDateTime AND BOTH hour AND minute are 0 (no cycle configured)
        // Flexible detection: day=0 AND no startDateTime AND (hour>0 OR minute>0) (explicit cycle configured)
        const isLegacy = Number(day) === 0 && !startDateTime && Number(hour) === 0 && Number(minute) === 0;

        if (isLegacy) {
            // Legacy: no hour/minute/startDateTime fields → treat as daily mode, 2 AM UTC
            initialFetchCycleDay = 1;
            initialFetchCycleHour = null;
            initialFetchCycleMinute = null;
            const today = new Date();
            const utc2am = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 2, 0, 0));
            fetchStartDateTime = utc2am;
        } else {
            // Use provided values (flexible or daily mode)
            const day = Number(props.data?.fetchCycleDay) || 0;
            initialFetchCycleDay = day;
            initialFetchCycleHour = Number(hour) || 0;
            initialFetchCycleMinute = Number(minute) || 0;
            if (startDateTime) {
                // Parse UTC string - DateTimePicker will display in user's local timezone
                fetchStartDateTime = new Date(startDateTime);
            } else {
                fetchStartDateTime = null;
            }
        }
    }

    return {
        name: props.data != null ? props.data.name : "Integration",
        id: props.isNew ? Utils.guidGenerator() : props.data.id,
        integrationClientId: props.isNew ? "" : props.data.integrationClientId,
        integrationClientSecret: props.isNew ? "" : props.data.integrationClientSecret,
        integrationUsername: props.isNew ? "" : props.data.integrationUsername,
        integrationPassword: props.isNew ? "" : props.data.integrationPassword,
        enabled: props.isNew ? "true" : props.data.enabled,
        fetchCycleDay: initialFetchCycleDay,
        fetchCycleHour: initialFetchCycleHour,
        fetchCycleMinute: initialFetchCycleMinute,
        // per‑mode caches (not persisted)
        cachedFlexibleHour: initialFetchCycleDay === 0 ? initialFetchCycleHour : null,
        cachedFlexibleMinute: initialFetchCycleDay === 0 ? initialFetchCycleMinute : null,
        cachedDailyHour: initialFetchCycleDay > 0 ? initialFetchCycleHour : null,
        cachedDailyMinute: initialFetchCycleDay > 0 ? initialFetchCycleMinute : null,
        // For daily mode date/time picker
        fetchStartDateTime: fetchStartDateTime,
        fetchCycleDayError: null,
        fetchCycleHourError: null,
        fetchCycleMinuteError: null,

        processingRegion: props.isNew ? "North Europe" : props.data.processingRegion,
        integrationType: props.isNew ? "Zoom" : props.data.integrationType,
        syncRecordingRule: props.isNew ? false : props.data.syncRecordingRule,
        allRecordings: props.isNew ? false : (props.data.allRecordings && (props.tenantData?.addOnN1Mapping > 0)),
        mappingUserId: (props.data == null || props.data.mappingUserId == null) ? [] : [{
            userId: props.data.mappingUserId
        }],
        folderName: props.isNew ? "" : props.data.folderName,
        leapXpertUserMappingField: props.isNew ? "Upn" : (props.data?.leapXpertUserMappingField || "Upn"),
        dynamicsCallObjectOpen: props.data?.dynamicsCallObjectOpen || false,
        archiveDynamicsCC: props.data?.archiveDynamicsCC || false,
        ttlCustomFieldMapping,
        genesysReportCustomField: props.isNew ? "" : props.data.genesysReportCustomField,
        customFieldMappings,
        filterAttribute,
        splitAudioInAgentSegments: props.isNew ? false : props.data.splitAudioInAgentSegments,
        daysUntilDeletion: props.isNew ? 0 : props.data.daysUntilDeletion,
        webexEnabledStorageRegions: props.data?.webexEnabledStorageRegions || "",
        awsRegion: props.isNew ? "" : props.data.awsRegion,
        cloud9AudioFormat: props.isNew ? "WAV" : props.data.cloud9AudioFormat,
    };

}

class IntegrationConfig extends React.Component {
    // Webex OAuth constants - single source of truth
    static WEBEX_OAUTH_SCOPES = "spark-compliance:recordings_read spark-compliance:webhooks_read spark-compliance:webhooks_write spark:people_read spark:kms";
    static WEBEX_OAUTH_REDIRECT_PATH = "/webex/";

    constructor(props) {
        super(props);
        this.state = getInitialState(props);
        this.webexRegionsList = ["US", "DE", "SG", "GB", "JP", "CA", "AU", "IN"];
        this.webexRegionsOptions = this.webexRegionsList.map(r => ({ key: r, text: r }));
        this.webexOAuthInProgress = false; // Guard against duplicate processing
    }

    handleWebexRegionsChange = (event, option) => {
        if (!option) return;

        // Get current selected regions
        let selectedRegions = this.state.webexEnabledStorageRegions
            ? this.state.webexEnabledStorageRegions.split(',').map(r => r.trim())
            : [];

        // Toggle the selected region
        const regionKey = option.key;
        const index = selectedRegions.indexOf(regionKey);

        if (index > -1) {
            selectedRegions.splice(index, 1); // Remove if selected
        } else {
            selectedRegions.push(regionKey); // Add if not selected
        }

        // Update state with comma-separated regions
        this.setState({ webexEnabledStorageRegions: selectedRegions.join(",") });
    };

    handleRemoveWebexRegion = (regionToRemove) => {
        // Remove a specific region from the selected list
        let selectedRegions = this.state.webexEnabledStorageRegions
            ? this.state.webexEnabledStorageRegions.split(',').map(r => r.trim())
            : [];

        selectedRegions = selectedRegions.filter(r => r !== regionToRemove);
        this.setState({ webexEnabledStorageRegions: selectedRegions.join(",") });
    };

    componentDidMount() {
        // Listen for OAuth callback messages from popup tabs
        console.log("IntegrationConfig mounted, setting up postMessage listener");
        window.addEventListener('message', this.handleOAuthCallback);
    }

    componentWillUnmount() {
        console.log("🧹 IntegrationConfig unmounting, removing postMessage listener");
        window.removeEventListener('message', this.handleOAuthCallback);
    }

    handleOAuthCallback = (event) => {
        // Only handle Webex OAuth messages - ignore all other postMessage events
        if (event.data?.type !== 'WEBEX_OAUTH_COMPLETE') {
            return; // Silently ignore non-Webex messages (React DevTools, etc)
        }

        // Guard against duplicate processing if message is received twice
        if (this.webexOAuthInProgress) {
            console.warn("⚠️ Webex OAuth already in progress, ignoring duplicate message");
            return;
        }

        // Security: Verify origin matches current location
        if (event.origin !== window.location.origin) {
            console.warn("⚠️ OAuth message from untrusted origin:", event.origin);
            return;
        }

        console.log("Received Webex OAuth callback from popup");
        console.log("   Code:", event.data.code?.substring(0, 20) + "...");
        console.log("   State:", event.data.state);

        this.webexOAuthInProgress = true; // Set guard BEFORE async call
        this.authenticateWebexWithCode(event.data.code, event.data.state);
    }

    authenticateWebexWithCode = async (code, integrationId) => {
        try {
            console.log("authenticateWebexWithCode called");
            console.log("   Code:", code?.substring(0, 20) + "...");
            console.log("   IntegrationId:", integrationId);

            // Build path string similar to what backend expects
            const path = `?code=${code}&state=${integrationId}`;
            console.log("   Calling GraphQL query with path:", path.substring(0, 50) + "...");

            // Call GraphQL to authenticate (backend handles token exchange)
            const result = await this.props.apol.query({
                query: gql`
                    query AuthenticateWebex($id: String!, $path: String!) {
                        authenticateWebex(id: $id, path: $path)
                    }
                `,
                variables: {
                    id: integrationId,
                    path: path
                }
            });

            console.log("GraphQL query response:", result);

            if (result.data.authenticateWebex) {
                console.log("Webex authentication successful!");

                // Use toast notification (production approach) instead of alert()
                toast.success('Webex authentication successful! Integration created.', {
                    position: "bottom-left",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });

                // Close modal autonomously after successful authentication
                if (this.props.closeModal) {
                    this.props.closeModal();
                }
            } else {
                console.error("❌ Webex authentication failed:", result.data);

                toast.error('Webex authentication failed. Please try again.', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        } catch (error) {
            console.error("❌ Error during Webex authentication:", error);
            console.error("   Error message:", error.message);
            console.error("   Error stack:", error.stack);

            toast.error('Error during authentication: ' + error.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            // Clear the guard to allow future OAuth attempts
            this.webexOAuthInProgress = false;
        }
    }


    // Update handleFetchCycleChange - now handles individual fields
    handleFetchCycleChange = (fieldName, value, context) => {
        // constraints per field
        let maxLength, min, max;
        if (fieldName === "fetchCycleDay") {
            maxLength = 2;
            min = 0;
            max = 30;
        } else if (fieldName === "fetchCycleHour") {
            maxLength = 2;
            min = 0;
            max = 23;
        } else if (fieldName === "fetchCycleMinute") {
            maxLength = 4;
            min = 0;
            max = 1380; // allow up to 23 hours in minutes for flexible cycles, but will validate multiples of 30 later
        }

        // normalize value to string (TextField sometimes passes undefined)
        const str = value == null ? "" : String(value);

        // basic input guards (digits only) 
        if (!isDigits(str, maxLength) && str !== "") return;
        if (str.length > maxLength) return;

        // per-field validation
        let error = null;
        const numValue = Number(str);
        if (str !== "") {
            if (fieldName === "fetchCycleDay" && (numValue < min || numValue > max)) {
                error = context.getTranslation("configuration", "integrationDayRangeError");
            } else if (fieldName === "fetchCycleHour" && (numValue < min || numValue > max)) {
                error = context.getTranslation("configuration", "integrationHourRangeError");
            } else if (fieldName === "fetchCycleMinute") {
                if (numValue > max) {
                    error = context.getTranslation("configuration", "integrationMinuteMaxRangeError");
                } else if (numValue > 0 && numValue % 30 !== 0) {
                    error = context.getTranslation("configuration", "integrationMinuteRangeError");
                }
            }
        }

        const stateUpdate = {
            [fieldName]: str,
        };

        // Set error for specific field
        if (fieldName === "fetchCycleDay") {
            stateUpdate.fetchCycleDayError = error;
        } else if (fieldName === "fetchCycleHour") {
            stateUpdate.fetchCycleHourError = error;
        } else if (fieldName === "fetchCycleMinute") {
            stateUpdate.fetchCycleMinuteError = error;
        }

        // handle mode switches (Day 0 <-> >0)
        if (fieldName === "fetchCycleDay") {
            const prevDay = Number(this.state.fetchCycleDay) || 0;
            const nextDay = Number(str) || 0;

            // Flexible (0) -> Daily (>0)
            if (prevDay === 0 && nextDay > 0) {
                // Set fetchStartDateTime so DateTimePicker shows local equivalent of 2 AM UTC
                const now = new Date();
                const utc2am = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 2, 0, 0));
                // This Date object, when shown in the picker, will display the local time equivalent of 2 AM UTC
                stateUpdate.fetchStartDateTime = utc2am;
                // Do NOT set fetchCycleHour, fetchCycleMinute, cachedDailyHour, or cachedDailyMinute in daily mode
            }

            // Daily (>0) -> Flexible (0)
            if (prevDay > 0 && nextDay === 0) {
                let hour = this.state.cachedFlexibleHour;
                let minute = this.state.cachedFlexibleMinute;

                if (hour == null || minute == null) {
                    hour = 0;
                    minute = 30;
                }

                // Set fetchStartDateTime to today at the cached/default time
                const today = new Date();
                const startDateTime = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    today.getDate(),
                    hour,
                    minute,
                    0
                );

                stateUpdate.fetchCycleHour = hour;
                stateUpdate.fetchCycleMinute = minute;
                stateUpdate.cachedFlexibleHour = hour;
                stateUpdate.cachedFlexibleMinute = minute;
            }
        }

        // editing in flexible mode (Day == 0), keep flexible cache in sync
        const currentDay = Number(fieldName === "fetchCycleDay" ? str : this.state.fetchCycleDay) || 0;
        if (currentDay === 0) {
            if (fieldName === "fetchCycleHour") {
                stateUpdate.cachedFlexibleHour = str === "" ? null : Number(str);
            }
            if (fieldName === "fetchCycleMinute") {
                stateUpdate.cachedFlexibleMinute = str === "" ? null : Number(str);
            }
        }
        this.setState(stateUpdate);
    };

    handleTTLFieldChange = (field, value) => {
        this.setState({
            ttlCustomFieldMapping: {
                ...this.state.ttlCustomFieldMapping,
                [field]: value
            }
        });
    };

    handleFilterAttributeChange = (field, value) => {
        this.setState({
            filterAttribute: {
                ...this.state.filterAttribute,
                [field]: value
            }
        });
    };

    handleCustomFieldInputChange = (index, value) => {
        const customFieldMappings = [...this.state.customFieldMappings];
        customFieldMappings[index].input = value;
        this.setState({ customFieldMappings });
    };

    handleTTLComboChange = (option) => {
        this.setState({
            ttlCustomFieldMapping: {
                ...this.state.ttlCustomFieldMapping,
                customfieldId: option.key
            }
        });
    };
    handleCustomFieldComboChange = (index, option) => {
        const customFieldMappings = [...this.state.customFieldMappings];
        customFieldMappings[index].combo = option.key;
        this.setState({ customFieldMappings });
    };

    handleAddCustomFieldRow = () => {
        this.setState({
            customFieldMappings: [...this.state.customFieldMappings, { input: "", combo: "" }]
        });
    };

    handleRemoveCustomFieldRow = (index) => {
        const customFieldMappings = [...this.state.customFieldMappings];
        customFieldMappings.splice(index, 1);
        this.setState({ customFieldMappings });
    };

    render() {

        const { hour, minute } = this.getDailyTime();
        return (
            <MyContext.Consumer>
                {(context) => (

                    <Stack vertical>
                        {/* name */}
                        <TextField type={"text"}
                            label={context.getTranslation("configuration", "jobName")}
                            value={this.state.name}
                            onChange={(event, newValue) => {
                                this.setState({ name: newValue });
                            }}
                        />

                        <Toggle
                            defaultChecked={this.state.enabled}
                            label={context.getTranslation("settings", "enabled")}
                            onText={context.getTranslation("settings", "on")}
                            offText={context.getTranslation("settings", "off")}
                            onChange={(ev, checked) => {
                                this.setState({
                                    enabled: checked,
                                    updated: true
                                });
                            }}
                        />


                        <br />
                        <hr />

                        <ComboBox
                            style={{ width: "300px" }}
                            placeholder="Select an option"
                            selectedKey={this.state.integrationType}
                            label={context.getTranslation("configuration", "integrationType")}
                            onChange={(ev, newVal) => {
                                this.setState({
                                    integrationType: newVal.key,
                                    updated: true
                                });
                            }}
                            options={[{
                                key: "Zoom",
                                text: "Zoom"
                            },
                            {
                                key: "Ringcentral",
                                text: "RingCentral",
                            },
                            {
                                key: "Cloud9",
                                text: "Cloud9",
                            },
                            {
                                key: "Genesys",
                                text: "Genesys",
                            },
                            {
                                key: "Dynamics",
                                text: "Dynamics",
                            },
                            {
                                key: "LeapXpert",
                                text: "LeapXpert",
                            },
                            {
                                key: "Webex",
                                text: "Webex",
                            }]
                            }
                        />
                        <br />

                        {/* Webex Storage Regions field - only show for Webex */}
                        {this.state.integrationType === "Webex" && (
                            <div style={{ marginBottom: 16 }}>
                                <ComboBox
                                    label="Webex Storage Regions"
                                    placeholder="Select regions (US, DE, SG, etc.)"
                                    selectedKey={null}
                                    onChange={this.handleWebexRegionsChange}
                                    allowFreeform={false}
                                    autoComplete="on"
                                    options={this.webexRegionsOptions}
                                    style={{ width: 300 }}
                                />
                                {this.state.webexEnabledStorageRegions && (
                                    <div style={{ marginTop: 8, padding: 8, backgroundColor: '#f0f0f0', borderRadius: 4 }}>
                                        <Text variant="small" style={{ fontWeight: 500 }}>Selected Regions:</Text>
                                        <div style={{ marginTop: 4 }}>
                                            {this.state.webexEnabledStorageRegions.split(',').map((region) => {
                                                const trimmedRegion = region.trim();
                                                return (
                                                    <span key={trimmedRegion} style={{
                                                        display: 'inline-block',
                                                        backgroundColor: '#00315E',
                                                        color: 'white',
                                                        padding: '4px 8px',
                                                        borderRadius: 3,
                                                        marginRight: 4,
                                                        marginBottom: 4,
                                                        fontSize: 12,
                                                        cursor: 'pointer',
                                                        userSelect: 'none'
                                                    }}>
                                                        {trimmedRegion}
                                                        <span
                                                            onClick={() => this.handleRemoveWebexRegion(trimmedRegion)}
                                                            style={{
                                                                marginLeft: 6,
                                                                fontWeight: 'bold',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </span>
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                                <Text variant="small" style={{ color: '#666', marginTop: 8, display: 'block' }}>
                                    Select specific Webex storage regions to fetch from. Leave empty to fetch from all regions.
                                </Text>
                            </div>
                        )}

                        {this.state.integrationType !== "LeapXpert" && this.state.integrationType !== "Webex" && this.state.integrationType !== "Cloud9" &&
                            <Label>{context.getTranslation("configuration", "integrationCredentials")}</Label>
                        }
                        {this.state.integrationType === "Webex" && this.props.isNew &&
                            <Label>{context.getTranslation("configuration", "WebexOAuthNote")}</Label>
                        }


                        {/* import connection string */}
                        <Stack.Item>
                            {(this.state.integrationType === "Dynamics" || this.state.integrationType === "Genesys") && <TextField label={context.getTranslation("configuration", "integrationClientId")}
                                value={this.state.integrationClientId}
                                onChange={(event, newValue) => {
                                    this.setState({ integrationClientId: newValue });
                                }}
                            />}
                            {(this.state.integrationType === "Dynamics" || this.state.integrationType === "Genesys") && <TextField label={context.getTranslation("configuration", "integrationClientSecret")}
                                value={this.state.integrationClientSecret}
                                type="password"
                                onChange={(event, newValue) => {
                                    this.setState({ integrationClientSecret: newValue });
                                }}
                            />}
                            {(this.state.integrationType !== "Ringcentral" && this.state.integrationType !== "LeapXpert" && this.state.integrationType !== "Cloud9") &&
                                <TextField label={context.getTranslation("configuration", this.state.integrationType === "Genesys" ? "regionUrl" : (this.state.integrationType === "Dynamics" ? "integrationDynamicsUrl" : "integrationUsername"))}
                                    value={this.state.integrationUsername}
                                    disabled={this.state.integrationType === "Zoom" || this.state.integrationType === "Webex" ? true : false}
                                    onChange={(event, newValue) => {
                                        this.setState({ integrationUsername: newValue });
                                    }}

                                />}
                            {this.state.integrationType === "Ringcentral" && <TextField label={context.getTranslation("configuration", "integrationJwtToken")}
                                value={this.state.integrationPassword}
                                type="password"
                                onChange={(event, newValue) => {
                                    this.setState({ integrationPassword: newValue });
                                }}
                            />}
                            {this.state.integrationType == "Zoom" && this.state.integrationUsername != "" &&
                                <DefaultButton onClick={this.authorizeWithZoom} text={context.getTranslation("configuration", "reauthenticateWithZoom")} />
                            }
                            {this.state.integrationType === "Webex" && this.state.integrationUsername != "" &&
                                <DefaultButton onClick={this.authorizeWithWebex} text={context.getTranslation("configuration", "reauthenticateWithWebex")} />
                            }
                            {/* Checkbox for DynamicsCallObjectOpen */}
                            {this.state.integrationType === "Dynamics" && (
                                <>
                                    <div style={{ marginTop: "16px" }}></div>
                                    <Checkbox
                                        label={context.getTranslation("configuration", "keepCallObjectOpen")}
                                        checked={this.state.dynamicsCallObjectOpen}
                                        onChange={(ev, checked) => {
                                            this.setState({ dynamicsCallObjectOpen: checked, updated: true });
                                        }}
                                    />
                                    <div style={{ marginTop: "8px" }}></div>
                                    {/* RI-19719: controlled availability - can only be activated directly in the database */}
                                    <Checkbox
                                        label={context.getTranslation("configuration", "archiveDynamicsCC")}
                                        checked={this.state.archiveDynamicsCC}
                                        disabled
                                    />
                                </>
                            )}

                            {(this.state.integrationType === "LeapXpert" || this.state.integrationType === "Cloud9") && <>

                                <TextField label={this.state.integrationType === "Cloud9" ? "S3 Bucket Name" : context.getTranslation("configuration", "folderName")}
                                    value={this.state.folderName}
                                    errorMessage={this.state.integrationType === "Cloud9" && !isValidS3BucketName(this.state.folderName) ? context.getTranslation("configuration", "Cloud9BucketNameError") : ""}
                                    onChange={(event, newValue) => {
                                        this.setState({ folderName: newValue });
                                    }}

                                />

                                {/* Only show AWS Region on EDIT (after save) */}
                                {!this.props.isNew && this.state.integrationType === "Cloud9" && (
                                    <TextField
                                        label="AWS Region"
                                        value={this.state.awsRegion || ""}
                                        readOnly={true}
                                        description="Data storage location"
                                    />
                                )}

                            </>}
                            {this.state.integrationType === "Cloud9" && (
                                <div style={{ marginTop: 16, marginBottom: 16 }}>
                                    <Label>
                                        <span>
                                            {context.getTranslation("configuration", "Cloud9AudioFormat")}
                                            <TooltipHost
                                                tooltipProps={{
                                                    onRenderContent: () => (
                                                        <>
                                                            <div>{context.getTranslation("configuration", "Cloud9AudioFormatTooltipMP3")}</div>
                                                            <div>{context.getTranslation("configuration", "Cloud9AudioFormatTooltipWAV")}</div>
                                                        </>
                                                    )
                                                }}
                                            >
                                                <Icon iconName="Info" style={{ marginLeft: 6, color: "rgb(0, 49, 94)", cursor: "pointer" }} />
                                            </TooltipHost>
                                        </span>
                                    </Label>

                                    <ChoiceGroup
                                        selectedKey={this.state.cloud9AudioFormat || "WAV"}
                                        onChange={(ev, option) => {
                                            this.setState({ cloud9AudioFormat: option.key, updated: true });
                                        }}
                                        options={[
                                            {
                                                key: "MP3",
                                                text: context.getTranslation("configuration", "Cloud9AudioFormatMP3"),
                                                styles: { field: { fontWeight: "400 !important" } }
                                            },
                                            {
                                                key: "WAV",
                                                text: context.getTranslation("configuration", "Cloud9AudioFormatWAV"),
                                                styles: { field: { fontWeight: "400 !important" } }
                                            }
                                        ]}
                                    />
                                </div>
                            )}
                        </Stack.Item>
                        {this.state.integrationType === "Genesys" && <>
                            <br />
                            <hr />
                            <Stack.Item>
                                <Label>{context.getTranslation("configuration", "participantDataMapping")}</Label>
                                {this.state.customFieldMappings.map((row, idx) => (
                                    <Stack horizontal key={idx} tokens={{ childrenGap: 8 }}>
                                        <TextField
                                            value={row.input}
                                            onChange={(e, newValue) => this.handleCustomFieldInputChange(idx, newValue)}
                                            placeholder={context.getTranslation("configuration", "field") + ` ${idx + 1}`}
                                            style={{ width: 180 }}
                                        />
                                        <Query
                                            query={getAllCustomFieldDefinitions}
                                            variables={this.props.authorization}>


                                            {({ loading, error, data }) => {
                                                if (loading) return <>
                                                    <Spinner label={context.getTranslation("common", "loadingData")} ariaLive="assertive" labelPosition="top" />
                                                </>;
                                                if (error) return <h1> </h1>;

                                                if (data.getAllCustomFieldDefinitions == null) {
                                                    return <div> </div>;

                                                }

                                                var customFieldsOptions = [];
                                                customFieldsOptions.push({ key: "Header1", text: "Custom Fields", itemType: SelectableOptionMenuItemType.Header });

                                                for (var i = 0; i < data.getAllCustomFieldDefinitions.length; i++) {
                                                    customFieldsOptions.push({
                                                        key: data.getAllCustomFieldDefinitions[i].id, text: data.getAllCustomFieldDefinitions[i].fieldName
                                                    })
                                                }

                                                return <span>
                                                    <ComboBox
                                                        id="selectFields"
                                                        style={{ width: "300px" }}
                                                        selectedKey={row.combo}
                                                        allowFreeform={false}
                                                        onChange={(ev, option) => this.handleCustomFieldComboChange(idx, option)}
                                                        autoComplete={true}
                                                        options={customFieldsOptions}
                                                        placeholder={context.getTranslation("configuration", "selectCustomField")}
                                                    />
                                                </span>
                                            }
                                            }
                                        </Query>
                                        <DefaultButton
                                            text={context.getTranslation("configuration", "deleteRow")}
                                            onClick={() => this.handleRemoveCustomFieldRow(idx)}
                                            disabled={this.state.customFieldMappings.length === 1}
                                        />
                                    </Stack>
                                ))}
                                <PrimaryButton
                                    text={context.getTranslation("configuration", "addRow")}
                                    onClick={this.handleAddCustomFieldRow}
                                    style={{ marginTop: 8 }}
                                />
                            </Stack.Item>

                            <Stack.Item>
                                <Label>{context.getTranslation("configuration", "ttlCustomFieldTitle")}</Label>
                                <Stack horizontal tokens={{ childrenGap: 8 }}>
                                    <TextField
                                        label={context.getTranslation("configuration", "ttlFieldKey")}
                                        value={this.state.ttlCustomFieldMapping.sourcekey}
                                        onChange={(e, newValue) => this.handleTTLFieldChange("sourcekey", newValue)}
                                        style={{ width: 120 }}
                                    />
                                    <TextField
                                        label={context.getTranslation("configuration", "ttlFieldValue")}
                                        value={this.state.ttlCustomFieldMapping.sourcevalue}
                                        onChange={(e, newValue) => this.handleTTLFieldChange("sourcevalue", newValue)}
                                        style={{ width: 120 }}
                                    />

                                    <Query
                                        query={getAllCustomFieldDefinitions}
                                        variables={this.props.authorization}>

                                        {({ loading, error, data }) => {
                                            if (loading) return <>
                                                <Spinner label={context.getTranslation("common", "loadingData")} ariaLive="assertive" labelPosition="top" />
                                            </>;
                                            if (error) return <h1> </h1>;

                                            if (data.getAllCustomFieldDefinitions == null) {
                                                return <div> </div>;

                                            }

                                            var customFieldsOptions = [];
                                            customFieldsOptions.push({ key: "Header1", text: "Custom Fields", itemType: SelectableOptionMenuItemType.Header });

                                            for (var i = 0; i < data.getAllCustomFieldDefinitions.length; i++) {
                                                customFieldsOptions.push({
                                                    key: data.getAllCustomFieldDefinitions[i].id, text: data.getAllCustomFieldDefinitions[i].fieldName
                                                })
                                            }

                                            return <span>
                                                <ComboBox
                                                    label={context.getTranslation("configuration", "ttlCustomField")}
                                                    id="selectFields"
                                                    style={{ width: "300px" }}
                                                    selectedKey={this.state.ttlCustomFieldMapping.customfieldId}
                                                    onChange={(ev, option) => this.handleTTLComboChange(option)}
                                                    options={customFieldsOptions}
                                                    placeholder={context.getTranslation("configuration", "selectCustomField")}
                                                />
                                            </span>
                                        }
                                        }
                                    </Query>
                                </Stack>
                            </Stack.Item>
                            <Stack.Item>
                                <Label>{context.getTranslation("configuration", "filterAttribute")}</Label>
                                <Stack horizontal tokens={{ childrenGap: 8 }}>
                                    <TextField
                                        label={context.getTranslation("configuration", "ttlFieldKey")}
                                        value={this.state.filterAttribute.key}
                                        onChange={(e, newValue) => this.handleFilterAttributeChange("key", newValue)}
                                        style={{ width: 120 }}
                                    />
                                    <TextField
                                        label={context.getTranslation("configuration", "ttlFieldValue")}
                                        value={this.state.filterAttribute.value}
                                        onChange={(e, newValue) => this.handleFilterAttributeChange("value", newValue)}
                                        style={{ width: 120 }}
                                    />
                                </Stack>
                            </Stack.Item>
                            <Stack.Item>
                                <TextField label={context.getTranslation("configuration", "genesysReportCustomField")}
                                    value={this.state.genesysReportCustomField}
                                    onChange={(event, newValue) => {
                                        this.setState({ genesysReportCustomField: newValue });
                                    }}

                                />
                            </Stack.Item>
                        </>}
                        <br />
                        <hr />

                        {/* Flexible Cycle Section */}
                        <Stack.Item>
                            <Label>
                                <span>
                                    {context.getTranslation("configuration", "integrationInterval")}
                                    <TooltipHost
                                        content={context.getTranslation("configuration", "integrationIntervalTooltipMessage")}
                                    >
                                        <Icon iconName="Info" style={{ marginLeft: 6, color: "rgb(0, 49, 94)", cursor: "pointer" }} />
                                    </TooltipHost>
                                </span>
                            </Label>
                            <Text variant="small" style={{ display: 'block', marginBottom: 8 }}>
                                {context.getTranslation("configuration", "integrationIntervalDescription")}
                            </Text>
                            {/* Day input */}
                            <TextField
                                label={
                                    <span>
                                        {context.getTranslation("configuration", "integrationDay")}
                                    </span>
                                }
                                type="text"
                                value={this.state.fetchCycleDay}
                                onChange={(e, value) => this.handleFetchCycleChange("fetchCycleDay", value, context)}
                                style={{ width: "100%" }}
                                description={context.getTranslation("configuration", "integrationDayDescription")}
                                errorMessage={this.state.fetchCycleDayError}
                                aria-invalid={!!this.state.fetchCycleDayError}
                                aria-describedby="dayError"
                                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                            />

                            {/* Daily Start Time Section - Show when Day > 0 */}
                            {Number(this.state.fetchCycleDay) > 0 && (
                                <Stack.Item>
                                    <Label>{context.getTranslation("configuration", "startTime")}</Label>

                                    <DateTimePicker
                                        locale={this.props.authorization.locale}
                                        calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}
                                        firstDayOfWeek={1}
                                        value={new Date(this.state.fetchStartDateTime)}
                                        onChange={(date) => {


                                            if (date) {
                                                console.log("Selected start date/time: ", date);

                                                // Store local time in state (what UI displays)
                                                this.setState({
                                                    fetchStartDateTime: date,
                                                    fetchCycleHour: date.getHours(),
                                                    fetchCycleMinute: date.getMinutes()
                                                });

                                            } else {
                                                // Reset to local 2 AM
                                                const today2amLocal = new Date();
                                                today2amLocal.setHours(2, 0, 0, 0);
                                                this.setState({
                                                    fetchStartDateTime: today2amLocal,
                                                    fetchCycleHour: 2,
                                                    fetchCycleMinute: 0
                                                });

                                            }
                                        }
                                        }
                                        minDate={new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 2, 0, 0)}
                                        maxDate={new Date(9999, 11, 31)}


                                    />

                                </Stack.Item>
                            )}

                            {/* Flexible Cycle Hour/Minute Section - Hide when Day > 0 */}
                            {Number(this.state.fetchCycleDay) === 0 && (
                                <>
                                    {/* Hour input */}
                                    <TextField
                                        label={
                                            <span>
                                                {context.getTranslation("configuration", "integrationHour")}
                                            </span>
                                        }
                                        type="text"
                                        value={this.state.fetchCycleHour}
                                        onChange={(e, value) => this.handleFetchCycleChange("fetchCycleHour", value, context)}
                                        style={{ width: "100%" }}
                                        description={context.getTranslation("configuration", "integrationHourDescription")}
                                        errorMessage={this.state.fetchCycleHourError}
                                        aria-invalid={!!this.state.fetchCycleHourError}
                                        aria-describedby="hourError"
                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                    />

                                    {/* Minute input */}
                                    <TextField
                                        label={
                                            <span>
                                                {context.getTranslation("configuration", "integrationMinute")}
                                            </span>
                                        }
                                        type="text"
                                        value={this.state.fetchCycleMinute}
                                        onChange={(e, value) => this.handleFetchCycleChange("fetchCycleMinute", value, context)}
                                        style={{ width: "100%" }}
                                        description={context.getTranslation("configuration", "integrationMinuteDescription")}
                                        errorMessage={this.state.fetchCycleMinuteError}
                                        aria-invalid={!!this.state.fetchCycleMinuteError}
                                        aria-describedby="minuteError"
                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                    />
                                </>
                            )}

                        </Stack.Item>

                        {this.state.integrationType === "LeapXpert" && (
                            <>
                                <br />
                                <hr />
                            </>
                        )}

                        {this.state.integrationType === "LeapXpert" && (
                            <ChoiceGroup
                                selectedKey={this.state.leapXpertUserMappingField}
                                label={context.getTranslation("configuration", "leapXpertUserMappingField")}
                                options={[
                                    {
                                        key: "Upn",
                                        text: context.getTranslation("configuration", "leapXpertMapByUpn"),
                                        styles: { field: { fontWeight: "400 !important" } }
                                    },
                                    {
                                        key: "Email",
                                        text: context.getTranslation("configuration", "leapXpertMapByEmail"),
                                        styles: { field: { fontWeight: "400 !important" } }
                                    },
                                ]}
                                onChange={(event, newValue) => {
                                    this.setState({ leapXpertUserMappingField: newValue.key, updated: true });
                                }}
                            />
                        )}

                        {this.state.integrationType !== "Cloud9" && (
                            <>
                                <br />
                                <hr />
                            </>
                        )}

                        {this.state.integrationType !== "Cloud9" &&
                            <Toggle
                                defaultChecked={this.state.syncRecordingRule}
                                label={context.getTranslation("configuration", this.state.integrationType !== "Dynamics" ? "integrationSyncRecordingRule" : "integrationSyncDynamics")}
                                onText={context.getTranslation("settings", "on")}
                                offText={context.getTranslation("settings", "off")}
                                onChange={(ev, checked) => {
                                    this.setState({
                                        syncRecordingRule: checked,
                                        updated: true
                                    });
                                }}
                            />}

                        {this.state.integrationType === "Genesys" &&
                            <Toggle
                                defaultChecked={this.state.allRecordings}
                                label={context.getTranslation("configuration", "allRecordings")}
                                onText={context.getTranslation("settings", "on")}
                                offText={context.getTranslation("settings", "off")}
                                onChange={(ev, checked) => {
                                    this.setState({
                                        allRecordings: checked,
                                        updated: true
                                    });
                                }}
                                disabled={!(this.props.tenantData?.addOnN1Mapping > 0)}
                            />}
                        {this.state.allRecordings && <Stack.Item>
                            <UserPicker
                                user={this.state.mappingUserId}
                                fc={(user) => {
                                    this.setState({
                                        mappingUserId: user,
                                        updated: true
                                    });
                                }}
                            />
                        </Stack.Item>}


                        {this.state.integrationType === "Genesys" && <div style={{ marginTop: "16px" }}>
                            <Checkbox
                                label={context.getTranslation("configuration", "splitAudioInAgentSegments")}
                                checked={this.state.splitAudioInAgentSegments}
                                onChange={(ev, checked) => {
                                    this.setState({ splitAudioInAgentSegments: checked, updated: true });
                                }}
                                style={{ marginTop: 16 }}
                            />
                        </div>
                        }

                        {this.state.integrationType === "Genesys" && <div style={{ marginTop: "16px" }}>
                            <TextField
                                label={context.getTranslation("configuration", "daysUntilDeletion")}
                                type="text"
                                value={this.state.daysUntilDeletion}
                                onChange={(e, value) => {
                                    this.setState({ daysUntilDeletion: Number(value) || 0, updated: true });
                                }}
                                style={{ width: "100%" }}
                                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                errorMessage={!isValidDaysUntilDeletion(this.state.daysUntilDeletion) ? context.getTranslation("configuration", "daysUntilDeletionRangeError") : ""}
                                aria-invalid={!isValidDaysUntilDeletion(this.state.daysUntilDeletion)}
                                aria-describedby="daysUntilDeletionError"
                            />
                        </div>
                        }

                        <br />
                        <hr />

                        <Query
                            query={getProcessingRegions}
                            variables={this.props.authorization} >
                            {({ loading, error, data }) => {
                                if (loading) return <div>
                                    <Spinner label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "loadingRegions")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                </div>;
                                if (error) return <h1> </h1>;

                                if (data.getProcessingRegions == null) {
                                    return <div></div>;
                                }

                                this.tmpKey = [];
                                const license = data.getProcessingRegions;
                                if (data.getProcessingRegions != null) {
                                    for (let x = 0; x < license.length; x++) {
                                        let i = {
                                            key: license[x],
                                            text: license[x],
                                        };
                                        this.tmpKey.push(i);
                                    }
                                }


                                return <ComboBox
                                    style={{ width: "300px" }}
                                    placeholder="Select an option"
                                    label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "processingRegion")}</>)}</MyContext.Consumer>}
                                    options={this.tmpKey}
                                    selectedKey={this.state.processingRegion}
                                    onChange={(ev, newVal) => {
                                        this.setState({
                                            processingRegion: newVal.key,
                                            updated: true
                                        });
                                    }}

                                />
                            }
                            }

                        </Query>
                        <br />

                        <br />

                        <Stack.Item>
                            <PrimaryButton onClick={this.savePanel} text={context.getTranslation("common", "save")} disabled={!this.isValid()} />
                            <DefaultButton onClick={this.resetState} text={context.getTranslation("common", "cancel")} />
                        </Stack.Item>
                    </Stack>
                )
                }
            </MyContext.Consumer>
        );
    }

    authorizeWithZoom = () => {
        // Open page to authorize with zoom
        window.open("https://zoom.us/oauth/authorize?response_type=code&client_id=" + this.state.integrationClientId + "&state=" + this.state.id + "&redirect_uri=" + window.location.origin + "/zoom", '_blank');
        this.resetState();
    }

    authorizeWithWebex = async () => {
        // Fetch Client ID from backend (public value, centralized in Key Vault)
        const result = await this.props.apol.query({
            query: gql`
            query { 
                getWebexOAuthConfig(region: "${this.state.processingRegion}") 
            }
        `
        });
        const clientId = result.data.getWebexOAuthConfig;
        const redirectUri = window.location.origin + IntegrationConfig.WEBEX_OAUTH_REDIRECT_PATH;

        console.log("  Webex OAuth Debug (re-authorize):");
        console.log("  Region:", this.state.processingRegion);
        console.log("  Client ID:", clientId);
        console.log("  Redirect URI:", redirectUri);
        console.log("  Requested Scopes:", IntegrationConfig.WEBEX_OAUTH_SCOPES);
        console.log("  Note: Actual granted scopes will be returned by Webex and stored in backend");

        // Build complete authorization URL
        const authUrl = "https://webexapis.com/v1/authorize?" +
            "response_type=code&" +
            "client_id=" + encodeURIComponent(clientId) + "&" +
            "scope=" + encodeURIComponent(IntegrationConfig.WEBEX_OAUTH_SCOPES) + "&" +
            "state=" + encodeURIComponent(this.state.id) + "&" +
            "redirect_uri=" + encodeURIComponent(redirectUri);

        console.log("  Complete Authorization URL:", authUrl);

        window.open(authUrl, '_blank', 'width=600,height=600');

        // Don't reset state - keep integration data so postMessage callback can use it
    }

    isValid = () => {
        // Existing logic
        const baseValid =
            (this.state.name != null && this.state.name.length > 0 &&
                (this.state.mappingType !== "UsersToComplianceOfficer" || this.state.mappingUserId.length > 0));

        // Require Client ID and Secret for integrations that need user-provided credentials
        // Note: Webex uses shared credentials from Key Vault, so it's excluded
        if (this.state.integrationType === "Dynamics" || this.state.integrationType === "Genesys") {
            if (!this.state.integrationClientId || !this.state.integrationClientSecret) {
                return false;
            }
        }

        // Validation for combined fields
        const { fetchCycleDayError, fetchCycleHourError, fetchCycleMinuteError } = this.state;

        // Check that no field has an error
        const hasNoFieldErrors = !fetchCycleDayError && !fetchCycleHourError && !fetchCycleMinuteError;
        const day = Number(this.state.fetchCycleDay) || 0;
        const hasCloud9Bucket = this.state.integrationType !== "Cloud9" || isValidS3BucketName(this.state.folderName);
        const hasValidDaysUntilDeletion = this.state.integrationType !== "Genesys" || isValidDaysUntilDeletion(this.state.daysUntilDeletion);

        // Daily mode → only need Day > 0 and no errors
        if (day > 0) {
            return baseValid && hasNoFieldErrors && hasCloud9Bucket && hasValidDaysUntilDeletion;
        }

        // Flexible mode → need positive cycle
        const hasPositiveCycle = this.getTotalCycleMinutes() > 0;

        return baseValid && hasNoFieldErrors && hasPositiveCycle && hasCloud9Bucket && hasValidDaysUntilDeletion;
    };

    resetState = () => {
        if (this.props.isNew) {
            this.setState({
                isPanelOpen: false,
                isModalOpen: false,
                isChanged: false,
                name: ""
            });
        } else {
            this.setState({
                isPanelOpen: false,
                isModalOpen: false,
                isChanged: false
            });
        }
        this.props.closeModal();
    }

    getDailyTime() {
        const hour = Number(this.state.fetchCycleHour) || 0;
        const minute = Number(this.state.fetchCycleMinute) || 0;
        return { hour, minute };
    }


    // Helper function to get total minutes from combined fields
    getTotalCycleMinutes = () => {
        const day = Number(this.state.fetchCycleDay) || 0;
        const hour = Number(this.state.fetchCycleHour) || 0;
        const minute = Number(this.state.fetchCycleMinute) || 0;
        return (day * 1440) + (hour * 60) + minute;
    }

    savePanel = () => {
        // Save Changes
        const { __typename: ttlTypename, ...ttlCustomFieldMappingClean } = this.state.ttlCustomFieldMapping;
        const { __typename: filterTypename, ...filterAttributeClean } = this.state.filterAttribute;
        console.log(this.state.mappingUserId);
        const customFieldDict = {};
        this.state.customFieldMappings.forEach(row => {
            if (row.input && row.combo) {
                customFieldDict[row.input] = row.combo;
            }
        });
        let job =
        {
            id: this.state.id,
            name: this.state.name,
            integrationType: this.state.integrationType,
            integrationClientId: this.state.integrationClientId,
            integrationClientSecret: this.state.integrationClientSecret,
            integrationUsername: this.state.integrationUsername,
            integrationPassword: this.state.integrationPassword,
            enabled: this.state.enabled ? true : false,
            fetchCycleDay: Number(this.state.fetchCycleDay),

            processingRegion: this.state.processingRegion,
            syncRecordingRule: this.state.syncRecordingRule,
            allRecordings: this.state.allRecordings,
            mappingUserId: (this.state.mappingUserId != null && this.state.mappingUserId.length > 0) ? this.state.mappingUserId[0].userId : null,
            folderName: this.state.folderName,
            leapXpertUserMappingField: this.state.leapXpertUserMappingField,
            dynamicsCallObjectOpen: this.state.dynamicsCallObjectOpen,
            ttlCustomFieldMapping: ttlCustomFieldMappingClean,
            filterAttribute: filterAttributeClean,
            genesysReportCustomField: this.state.genesysReportCustomField,
            customFieldMappings: JSON.stringify(customFieldDict),
            archiveDynamicsCC: this.state.archiveDynamicsCC,
            splitAudioInAgentSegments: this.state.splitAudioInAgentSegments,
            daysUntilDeletion: Number(this.state.daysUntilDeletion) || 0,
            webexEnabledStorageRegions: this.state.webexEnabledStorageRegions || null,
            awsRegion: this.state.awsRegion || null,
            cloud9AudioFormat: this.state.cloud9AudioFormat,
        };
        // Only include hour/minute for flexible mode, startDateTime for daily mode
        const mode = detectMode(this.state.fetchCycleDay, this.state.fetchCycleHour, this.state.fetchCycleMinute, this.state.fetchStartDateTime);
        if (mode === "flexible") {
            job.fetchCycleHour = Number(this.state.fetchCycleHour);
            job.fetchCycleMinute = Number(this.state.fetchCycleMinute);
        }
        if (mode === "daily" && this.state.fetchStartDateTime) {
            job.fetchStartDateTime = this.state.fetchStartDateTime.toISOString();
        }
        console.log("Saving integration job - Local time on UI:", this.state.fetchStartDateTime, "UTC time to backend:", this.state.fetchStartDateTime ? this.state.fetchStartDateTime.toISOString() : "N/A (flexible mode)");

        if (!this.props.isNew) {

            this.props.apol
                .mutate({
                    mutation: gql`
                    mutation ent (
                        $input: AuthInput, $integrationJob: IntegrationRuleInputType) {
                        updateIntegrationJob (
                            input: $input, 
                            integrationJob: $integrationJob
                        ) 
                        {
                            id,
                            integrationUsername,
                            fetchCycleDay,
                            fetchCycleHour,
                            fetchCycleMinute,
                            fetchStartDateTime,
                            webexEnabledStorageRegions,
                            awsRegion,
                            cloud9AudioFormat
                        }
                    }
                `,
                    refetchQueries: [{
                        query: queryGetConfigData,


                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        input: this.props.authorization,
                        integrationJob: job
                    },
                })
                .then((result) => {
                    toast.info('Integration Job changed', {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    this.props.closeModal();
                })
                .catch((error) => {
                    const errorMessage =
                        error.graphQLErrors?.[0]?.message ||
                        error.message ||
                        'Failed to update integration';

                    toast.error(errorMessage, {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    // Modal stays open so user can fix the error
                });
        }
        else {
            this.props.apol
                .mutate({
                    mutation: gql`
                    mutation ent (
                        $input: AuthInput, $integrationJob: IntegrationRuleInputType) {
                        createIntegrationJob (
                            input: $input, 
                            integrationJob: $integrationJob
                        ) 
                        {
                            id,
                            integrationClientId,
                            integrationUsername,
                            fetchCycleDay,
                            fetchCycleHour,
                            fetchCycleMinute,
                            fetchStartDateTime,
                            webexEnabledStorageRegions,
                            awsRegion,
                            cloud9AudioFormat
                        }
                    }
                `,
                    refetchQueries: [{
                        query: queryGetConfigData,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        input: this.props.authorization,
                        integrationJob: job
                    },
                })
                .then((result) => {
                    toast.info('Integration Job created', {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    if (this.state.integrationType == "Zoom") {
                        window.open("https://zoom.us/oauth/authorize?response_type=code&client_id=" + result.data.createIntegrationJob.integrationClientId + "&state=" + result.data.createIntegrationJob.id + "&redirect_uri=" + window.location.origin + "/zoom", '_blank');
                        this.props.closeModal();
                    } else if (this.state.integrationType === "Webex") {
                        // Fetch Client ID from backend (centralized in Key Vault)
                        this.props.apol.query({
                            query: gql`
                                query { 
                                    getWebexOAuthConfig(region: "${this.state.processingRegion}") 
                                }
                            `
                        }).then(configResult => {
                            const clientId = configResult.data.getWebexOAuthConfig;
                            const redirectUri = window.location.origin + IntegrationConfig.WEBEX_OAUTH_REDIRECT_PATH;

                            console.log("  Webex OAuth Debug (new integration):");
                            console.log("  Region:", this.state.processingRegion);
                            console.log("  Client ID:", clientId);
                            console.log("  Redirect URI:", redirectUri);
                            console.log("  Requested Scopes:", IntegrationConfig.WEBEX_OAUTH_SCOPES);

                            // Build complete authorization URL
                            const authUrl = "https://webexapis.com/v1/authorize?" +
                                "response_type=code&" +
                                "client_id=" + encodeURIComponent(clientId) + "&" +
                                "scope=" + encodeURIComponent(IntegrationConfig.WEBEX_OAUTH_SCOPES) + "&" +
                                "state=" + encodeURIComponent(result.data.createIntegrationJob.id) + "&" +
                                "redirect_uri=" + encodeURIComponent(redirectUri);

                            console.log("  Complete Authorization URL:", authUrl);
                            console.log("  Note: Verify 'spark:people_read' is in the URL above");
                            console.log("  Note: Actual granted scopes will be returned by Webex and stored in backend");

                            window.open(authUrl, '_blank', 'width=600,height=600');
                            // NOTE: Modal will close when postMessage callback completes (authenticateWebexWithCode)
                        });
                        // For Webex, DON'T close modal - let OAuth callback close it
                    } else {
                        this.props.closeModal();
                    }
                })
                .catch((error) => {
                    const errorMessage =
                        error.graphQLErrors?.[0]?.message ||
                        error.message ||
                        'Failed to create integration';

                    toast.error(errorMessage, {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    // Modal stays open so user can fix the error
                });
        }


    };
}



export default IntegrationConfig;